<template>
  <div class="add-group">
    <div class="group-inputs">
      <label>{{ $t('groupName') }}</label>
      <v-text-field
        :placeholder="$t('groupName')"
        v-model="group_name"
        outlined
      >
      </v-text-field>
    </div>
    <div class="group-inputs unique_ename">
      <label>{{ $t('groupId') }}</label>
      <v-text-field
        :placeholder="$t('groupIdEnglish')"
        v-model="group_enName"
        :hint="check_msg"
        @keypress="isLetter($event)"
        outlined
      >
      </v-text-field>
    </div>

    <div class="select-contact">
      <p>{{ $t('selectTwoMember') }}</p>
      <div class="contact-preview"  v-for="(item , i) in items"  v-bind:key="item.UserContactId" v-on:click="select_contact(i)" v-bind:class="{'is-select': item.IsSelected} ">
        <div class="row" >
          <div class="col-2 no-padding-l" >
            <img :src="item.ImageUrl" />
          </div>
          <div class="col-6">
          <span class="contact-username">
            {{ item.UserName }}
          </span>
          </div>
          <div class="col-4">
          <span class="contact-code">
            {{ item.UserCode }}
          </span>
          </div>
        </div>
      </div>
      <button class="btn add-group-btn" v-on:click="addGroup()">{{ $t('add') }}</button>
    </div>

  </div>
</template>

<script>

import { bus } from '../../main'

export default {
  data () {
    return {
      items: '',
      isSelect: false,
      phone: '',
      password: '',
      lastItemId: 0,
      lastLogId: 0,
      group_name: '',
      group_enName: '',
      selectedItem: [],
      check_msg: '',
      check_flag: false,
    }
  },
  watch: {
    group_enName : function (val) {
      const param = {
        Code:  val
      }
      var self = this
      this.axios.post('/CheckExistsCode', param, {})
        .then(response => {
          if (response.data.error == 0) {
            console.log('CheckExistsCode ', response.data)
            this.check_msg = response.data.msg
            this.check_flag = true
            // check = true;
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {

      })
    }

  },
  methods: {
    isLetter (e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[a-zA-Z0-9_]+$/.test(char)) return true
      else e.preventDefault()
    },
    select_contact (i) {
      this.selectedItem = []
      var data = this.items[i]
       if (data.IsSelected == true) {
         data.IsSelected = false
         this.items.splice(i, 1, data) // replace it
       } else {
         data.IsSelected = true
         this.items.splice(i, 1, data) // replace it
         // this.selectedItem.push(this.items[i]);
       }
      for (var j = 0; j < this.items.length; j++) {
        if (this.items[j].IsSelected == true) {
          const selectObj = {
            MemberId: this.items[j].UserContactId,
            MemberName : this.items[j].UserName
          }
          this.selectedItem.push(selectObj)
        }
      }
      console.log('this.selectedItem :' + JSON.stringify(this.items))
      console.log('this.selectedItem :' + i)
    },
    getAllContacts () {
      this.phone = localStorage.getItem('phone')
      this.password = localStorage.getItem('password')
      const send_data = {
        Phone:this.phone,
        Password: this.password,
        LastItemId: this.lastItemId,
        LastLogId: this.lastLogId
      }
      var self = this
      this.axios.post('/ShowAllGroupContacts', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.items = response.data.contacts
            for (var i = 0; i < this.items.length; i++) {
              this.items[i].IsSelected = false
              console.log('test :' + JSON.stringify(this.items[i]))
            }
          }
        }).catch(e => {

      })
    },


    addGroup () {
      if (this.check_flag) {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        if (this.group_enName.startsWith('@') == false) {
          var str1 = '@'
          var eName = str1.concat(this.group_enName)
        } else {
          var eName = this.group_enName
        }
        // var checked = this.checkCode(this.group_enName);
        // console.log(checked)

        var self = this
        // if( checked==true ){
        const send_data = {
          GroupName:this.group_name,
          GroupCode: eName,
          OwnerId: user_data.UserId,
          OwnerName: user_data.UserName,
          Password: this.password,
          Members: this.selectedItem,
        }
        this.axios.post('/AddGroup', send_data, {})
          .then(response => {
            if (response.data.error == 0) {

              bus.$emit('show_toast', [1500, response.data.msg])
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {

        })
        // }
      }
    }

  },
  mounted () {
    this.getAllContacts()
  }
}
</script>
